import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule} from '../../shared/shared.module';
import { TranslateModule } from '../../translate';
import { MaterialModule } from '../../shared/material.module';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateNewThermographyInspectionComponent } from './create-new-thermography-inspection/create-new-thermography-inspection.component';
import { InspSystemComponent } from './create-new-thermography-inspection/insp-system/insp-system.component';
import { UploadPhotoComponent } from '../interpretation/components/upload-photo/upload-photo.component';
import { ThermographyInspectionService} from './thermography-inspection.service';
import { InterpretationModule } from '../interpretation/interpretation.module';

@NgModule({
    declarations: [
        CreateNewThermographyInspectionComponent,
        InspSystemComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        TranslateModule,
        MaterialModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        InterpretationModule,
    ],
    providers: [
        ThermographyInspectionService
    ]
})
export class ThermorgraphyInspectionModule { }
